export const AvailablePages = [
  { label: "Homepage", value: "homepage" },
  { label: "Outcomes", value: "outcomes" },
  { label: "All Pages", value: "all" },
];
